var _style, _path, _g, _g2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgroconsult({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1023.6 379.5",
    style: {
      enableBackground: "new 0 0 1023.6 379.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000022557517885066801020000005007441242762682531_);}\n\t.st2{fill:url(#SVGID_00000078012062745502344100000012925764282213875867_);}\n\t.st3{fill:url(#SVGID_00000089563824910626342380000000393343535251158190_);}\n\t.st4{fill:url(#SVGID_00000136371111221733632600000000197729929963933327_);}\n\t.st5{fill:url(#SVGID_00000161625381884147060520000016061307153897912974_);}\n\t.st6{fill:#1D1D1B;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:url(#SVGID_00000150796718021592118930000013051157999024818599_);}\n\t.st9{fill:url(#SVGID_00000099620863239076160170000009427277313213295530_);}\n\t.st10{fill:url(#SVGID_00000137821312851957804850000001614361520244315574_);}\n\t.st11{fill:#575756;}\n\t.st12{font-family:'Comfortaa';}\n\t.st13{font-size:44.8892px;}\n\t.st14{font-size:218.1558px;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.144,
    y1: 196.3713,
    x2: 232.9993,
    y2: 196.3713
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3155,
    style: {
      stopColor: "#202956"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008747"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.1,196.4c0,29.7,24.2,53.9,53.9,53.9h0c29.7,0,53.9-24.2,53.9-53.9c0-29.7-24.2-53.9-53.9-53.9 S125.1,166.6,125.1,196.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010306756718100821860000015263544129721469093_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.6584,
    y1: 196.3708,
    x2: 311.4862,
    y2: 196.3708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3155,
    style: {
      stopColor: "#202956"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008747"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010306756718100821860000015263544129721469093_)"
    },
    d: "M287.6,327.4v-27.7c0-1.8-1.3-4.1-2.9-5.1 l-25.5-16c-1.3-0.8-1.4-1.5-0.3-1.7h-73.9h-5.9c0,0,0,0,0,0c0,0,0,0,0,0h-2.5c-0.3,0-0.6,0-0.8-0.1c-44.1-1.8-79.2-39.4-77-84.4 c2.1-41.2,35.8-74.6,77-76.2c45.7-1.9,83.5,34.7,83.7,80c0,0,0,0.1,0,0.1v75.5h52V196c0,0,0-0.1,0-0.1 C311.2,120.6,247.9,60,171.7,64.2c-67.9,3.7-122.5,59.3-125,127.3c-2.7,73.4,54.7,134.2,126.8,137.2c0.4,0.1,0.9,0.1,1.4,0.1h4.1 c0,0,0,0,0,0c0,0,0,0,0,0H288C287.7,328.5,287.6,328,287.6,327.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010993598607142611850000005216921269967215027_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.1318,
    y1: 306.7029,
    x2: 299.7028,
    y2: 306.7029
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3155,
    style: {
      stopColor: "#202956"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008747"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010993598607142611850000005216921269967215027_)"
    },
    d: "M362.2,276.7h-98c-1.9,0-2.2,0.8-0.6,1.8 l25.5,16c1.6,1,2.9,3.3,2.9,5.1v27.7c0,1.8,1.2,2.4,2.8,1.3l8-5.7c1.5-1.1,3.5-0.6,4.3,1l6,11.3c0.9,1.6,2.5,1.8,3.7,0.4l46.7-56.4 C364.7,277.9,364.1,276.7,362.2,276.7z M304.1,296.2l40.7-8.5c1.9-0.4,2.4,0.5,1.2,1.9l-27.9,33.8c-1.2,1.4-2.8,1.3-3.7-0.4 l-12.2-23.2C301.4,298.2,302.3,296.6,304.1,296.2z M331.6,284l-31.8,6.6c-1.9,0.4-4.7-0.1-6.3-1.1l-6.9-4.3c-1.6-1-1.3-1.8,0.6-1.8 h44.3C333.4,283.3,333.4,283.6,331.6,284z M298.9,314.2v-2.4c0-1.8,0.7-2,1.5-0.3l0.4,0.7c0.9,1.6,0.8,3.5-0.2,4.2 C299.7,317,298.9,316.1,298.9,314.2z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 461.6988 315.7155)",
    className: "st11 st12 st13"
  }, "powered by agroconsult"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M371.6,64.3c2.1,0,3.7,2.1,4.7,6.4c13.9,36.2,20.9,54.7,21,55.5v0.5c0,1.7-1.1,2.8-3.3,3.1h-0.2 c-2,0-3.5-2-4.3-5.9l-7.8-20.1h-20.2l-9.5,25c-0.9,0.7-1.7,1.1-2.4,1.1h-0.4c-2.2-0.4-3.3-1.5-3.3-3.3v-0.2l5.9-15.9 c10.3-26.7,15.8-41.5,16.7-44.5C369.7,64.9,370.7,64.3,371.6,64.3z M371.6,77.5l-7.3,19.6h14.8v-0.2l-7.4-19.5H371.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M433.9,64c7,0,13.3,2,18.9,5.9c0.6,0.8,0.9,1.5,0.9,2.2v0.2c0,1.8-1.2,2.9-3.5,3.3c-0.4,0-2.6-1-6.7-2.9 c-2.7-1-5.3-1.6-7.8-1.6h-2.8c-6.5,0-12.6,3.1-18.5,9.4c-3.8,5.2-5.7,10.6-5.7,16.1v0.7c0,9,4.2,16.3,12.5,22 c4.3,2.4,8.7,3.7,13,3.7h0.7c4.3,0,8.6-1.2,12.9-3.5v-15.8h-12.5c-2.2-0.4-3.3-1.5-3.3-3.3v-0.1c0.4-2.2,1.5-3.3,3.3-3.3h16.2 c1.7,0,2.8,1.1,3.1,3.3v19.2c0,2.8-0.7,4.6-2.1,5.2c-5.9,3.5-11.6,5.2-17.2,5.2h-1c-10.9,0-20-5-27.3-15.1 c-3.5-5.7-5.2-11.6-5.2-17.9c0-11,4.9-20.2,14.7-27.4C422.4,65.8,428.2,64,433.9,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M462.7,64h14.5c6.2,0,11.2,3.2,15.1,9.7c1.3,2.5,1.9,5.1,1.9,7.8v0.7c0,6.1-3,11-8.9,14.9l-1.7,0.9 c10.5,18.1,15.8,27.4,15.8,27.8v0.9c0,1.7-1.1,2.8-3.3,3.1h-0.2c-1.7,0-3.4-2-5.2-5.9l-14.3-24.3h-9.9v27.1c0,1.7-1.1,2.8-3.3,3.1 h-0.2c-1.8,0-2.9-1.2-3.3-3.5V67.9C460,65.3,461,64,462.7,64z M466.6,70.6v22.3h9.9c5.5,0,9.1-3,10.8-8.9l0.2-1.4v-1.4 c0-4.3-2.4-7.6-7.3-9.9c-1.4-0.5-3.5-0.7-6.4-0.7H466.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M536.2,64c11.1,0,20.4,5.1,27.9,15.4c3.4,5.8,5,11.7,5,17.7c0,11-5,20.1-14.9,27.4 c-5.6,3.6-11.5,5.4-17.7,5.4h-0.7c-11.3,0-20.6-5.3-27.7-15.8c-3.2-5.3-4.9-11.1-4.9-17.3c0-10.5,4.6-19.3,13.9-26.5 C523.1,66.1,529.5,64,536.2,64z M510,97.3c0,8.4,3.7,15.4,11.1,21.2c4.6,3.1,9.5,4.7,14.7,4.7h0.9c8.2,0,15.1-3.6,20.8-10.9 c3.2-4.7,4.9-9.8,4.9-15.3c0-9.5-4.3-17-13-22.5c-4.3-2.4-8.7-3.7-13.2-3.7c-8.7,0-15.8,3.8-21.5,11.3 C511.6,86.5,510,91.6,510,97.3z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 330.9646 269.0875)",
    className: "st11 st12 st14"
  }, "envios")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgroconsult);
export default __webpack_public_path__ + "static/media/agroconsult.cee0355f7bd3854fcaff903521b0ff3f.svg";
export { ForwardRef as ReactComponent };